import { styled } from "@mui/styles";
import Box from "@mui/material/Box";

export const StyledShareFundraiserModal = styled(Box)(({ theme }) => ({
    paddingBottom: '20px',

    '& .IconsStack': {
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        '& .react-share__ShareButton': {
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
            alignItems: 'center',
            justifyContent: 'flex-end'
        }
    },

    '& .CopyUrlStack': {
        flexDirection: 'row',
        alignItems: 'center',
        gap: '10px'
    }
}))